import React from "react";
import { Text, View, Font } from "@react-pdf/renderer";
import { styles } from "../GenericPdf/style";
import { SinglePdfHeaderType } from "../GenericPdf/constant";
import { handleHeaderDescriptionWidth, handleOthersWidth } from "../CommonPdfComponents/utils";


Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
      fontWeight: 600,
    },
    {
      src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf",
      fontWeight: 700,
    },
  ],
});

type AppProps = {
  tableHeaders: SinglePdfHeaderType[];
};

const InvoiceTableHeader = ({ tableHeaders }: AppProps) => {
 
  const headerBody = () => {
    let finalHeader = tableHeaders?.filter(header => header.name && header.column_value)?.map((header: SinglePdfHeaderType) => {
   
      return (
        <Text
          style={
            header?.column_value === "description"
              ? {
                  ...styles.description,
                  ...styles.table_headers,
                  color: "#dd4433",
                  fontSize: "8px",
                  paddingTop: "8px",
                  width: handleHeaderDescriptionWidth(tableHeaders?.length),
                }
              : header?.column_value === "no"
              ? {
                  ...styles.no,
                  ...styles.table_headers,
                  color: "#dd4433",
                  paddingTop: "8px",
                  paddingLeft: "1px",
                }
              : header?.column_value === "quantity"
              ? {
                  ...styles.table_width,
                  ...styles.table_headers,
                  color: "#dd4433",
                  paddingTop: "8px",
                  paddingLeft: "1px",
                  width: "8%",
                }
              : {
                  ...styles.table_width,
                  ...styles.table_headers,
                  width:  handleOthersWidth(tableHeaders?.length),
                  color: "#dd4433",
                  paddingTop: "8px",
                }
          }
        >
          {header?.name}
        </Text>
      );
    });
      
    return finalHeader;
  };

  return <View style={styles.container}>{headerBody()}</View>;
};

export default InvoiceTableHeader;
